import { SPACE_DETAILS } from '@/route-names';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export default function useSpaceRouteContext() {
  const route = useRoute();
  const routeSpaceId = computed(() => (route.name === SPACE_DETAILS ? parseInt(route.params.optionId, 10) : null));
  return { routeSpaceId };
}
